import Add from "@mui/icons-material/Add";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { RecipientCard } from "../components/RecipientCard";
import {
  defaultRecipientForm,
  useCommunicationFormContext,
} from "../hooks/useCommunicationForm";

export const RecipientsStep = () => {
  const { watch, setValue, mode } = useCommunicationFormContext();
  const recipients = watch("recipients");
  const disabled = mode === "view";

  const handleAddRecipient = useCallback(() => {
    setValue("recipients", [...recipients, defaultRecipientForm()]);
  }, [recipients, setValue]);

  const handleRemoveRecipient = useCallback(
    (index: number) => {
      if (recipients.length === 1) {
        setValue("recipients", [defaultRecipientForm()], {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else {
        // shallow copy, then remove the recipient from the copy
        const newRecipients = [...recipients];
        newRecipients.splice(index, 1);
        setValue("recipients", newRecipients, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }
    },
    [recipients, setValue]
  );

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle1">Recipient(s)</Typography>
      <Stack divider={<Divider sx={{ mb: 3, mr: 9 }} />}>
        {recipients.map((recipient, index) => (
          <RecipientCard
            key={recipient.rowId}
            index={index}
            onRemove={() => handleRemoveRecipient(index)}
          />
        ))}
      </Stack>

      {!disabled && (
        <Box>
          <Button
            onClick={handleAddRecipient}
            disabled={disabled}
            size="small"
            color="primary"
            startIcon={<Add />}
          >
            Add Recipient
          </Button>
        </Box>
      )}
    </Stack>
  );
};
